module.exports = __webpack_public_path__ + "img/content.1cf1b79a.png";